import { ChangeDetectorRef, Component, OnInit ,Inject} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'blog-modal',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent,NgStyle, NgClass, RouterLink,MatTooltipModule,MatDialogModule],
  templateUrl: './blog-modal.component.html',
  styleUrl: './blog-modal.component.scss'
})
export class BlogModalComponent implements OnInit {
  

  public view: any = {
  }
  openModal() {
  }
  closeModal() {
    this.dialogRef.close();
  }
  constructor(public dialogRef: MatDialogRef<BlogModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  ngOnInit(): void {
  }
}

